const CL = [
	{
		side: "Away / Group stage",
		team: "Young Boys",
		result: "2-1",
		possession: "46 %",
		shots: 2,
		onTarget: 2,
		passes: 410,
		passesCompleted: 342,
		tackles: 12,
		aerial: 17,
	},
	{
		side: "Home / Group stage",
		team: "Villarreal",
		result: "2-1",
		possession: "56 %",
		shots: 14,
		onTarget: 7,
		passes: 554,
		passesCompleted: 500,
		tackles: 9,
		aerial: 13,
	},
	{
		side: "Home / Group stage",
		team: "Atalanta",
		result: "3-2",
		possession: "56 %",
		shots: 22,
		onTarget: 9,
		passes: 554,
		passesCompleted: 468,
		tackles: 6,
		aerial: 12,
	},
	{
		side: "Away / Group stage",
		team: "Atalanta",
		result: "2-2",
		possession: "53 %",
		shots: 13,
		onTarget: 4,
		passes: 566,
		passesCompleted: 468,
		tackles: 14,
		aerial: 10,
	},
	{
		side: "Away / Group stage",
		team: "Villarreal",
		result: "0-2",
		possession: "49 %",
		shots: 11,
		onTarget: 6,
		passes: 478,
		passesCompleted: 418,
		tackles: 6,
		aerial: 8,
	},
	{
		side: "Home / Group stage",
		team: "Young Boys",
		result: "1-1",
		possession: "49 %",
		shots: 7,
		onTarget: 5,
		passes: 496,
		passesCompleted: 400,
		tackles: 13,
		aerial: 4,
	},
	{
		side: "Away / Round of 16",
		team: "Atletico Madrid",
		result: "1-1",
		possession: "63 %",
		shots: 7,
		onTarget: 2,
		passes: 541,
		passesCompleted: 447,
		tackles: 10,
		aerial: 18,
	},
	{
		side: "Home / Round of 16",
		team: "Atletico Madrid",
		result: "0-1",
		possession: "60 %",
		shots: 11,
		onTarget: 5,
		passes: 573,
		passesCompleted: 478,
		tackles: 4,
		aerial: 18,
	},
];
export default CL;
